import axios from "axios";

const Services = {
    get(slug) {
        return axios.get(`${process.env.API1}/api/services/${slug}`);
    },
    getCoverage(params) {
        return axios.post(`${process.env.API1}/api/seats/coverage`, params);
    },
    getProductoBySlug(params) {//detalle de un producto
        return axios.post(`${process.env.API1}/api/product`, params);
    },
    getProducts(params) { //lista de productos por servicio
      return axios.post(`${process.env.API1}/api/services/products`, params);
    },
    getPopup(params){
      return axios.post(`${process.env.API1}/api/services/popups`, params);
    },
    getRenovacionEp(params){
      return axios.get(`${process.env.API1}/api/customer/${params}`);
    },
    getReniecSunat(slug, data){
      return axios.post(`${process.env.API2}/${slug}/${data}`,{})
  }
}

export default Services



// WEBPACK FOOTER //
// ./src/services/services.service.js